export default {
  type: 'Home',
  sections: [
    { id: 'home1', title: 'Home Insurance Introduction' },
    { id: 'htgbr', title: 'How to Get The Best Rate' },
    { id: 'coverage', title: 'Components and Coverage' },
    { id: 'home2', title: 'Main Price Impacting Factors' }
  ],
  introData: {
    title: 'Home Insurance Guide',
    paragraphs: [
      "Welcome to Insurance Express's home insurance guide! We're dedicated to helping homeowners protect their biggest investment by offering the best coverage at affordable rates. With years of experience in the industry, we have the knowledge and expertise to help you understand the ins and outs of home insurance.",
      "As a leading provider of home insurance in our region, we have access to a variety of insurance markets, allowing us to offer a wide range of coverage options to our clients. In this guide, we'll explain what home insurance is, the different types of policies available, and provide tips on how to get the best rate on your policy.",
      "Whether you're a first-time homeowner or looking to switch your existing policy, we hope that this guide will provide you with the information you need to make an informed decision. So, let's get started!"
    ]
  },
  bestRateTips: [
    "Shop around: It's important to get quotes from multiple insurance providers to ensure you're getting the best rate. Use online comparison tools or work with an independent insurance agent who can help you navigate the market.",
    "Bundle policies: Many insurance companies offer discounts for customers who bundle their home insurance policy with other types of insurance, such as auto or life insurance.",
    "Increase your deductible: The higher your deductible (the amount you pay out of pocket before insurance kicks in), the lower your monthly premium will be. Consider increasing your deductible if you have savings to cover the higher amount.",
    "Improve your credit score: Many insurance companies use credit scores as a factor in determining rates. By improving your credit score, you may be able to get a better rate on your home insurance policy.",
    "Ask about discounts: Many insurance providers offer discounts for various reasons, such as having a security system installed, being a senior citizen, or having a good claims history. Be sure to ask your insurance provider about any available discounts."
  ],
  briefGuide: "Owning a home is one of the biggest investments you can make in your lifetime. That's why it's important to protect your investment with a good home insurance policy. Home insurance not only covers damages to your property caused by unexpected events, but it also provides liability protection if someone is injured while on your property.",
  coverageItems: [
    "What is home insurance and why is it important",
    "Types of home insurance policies: HO-1, HO-2, and HO-3",
    "Components of a home insurance policy: dwelling coverage, personal property coverage, liability coverage, and additional living expenses",
    "What does home insurance typically cover?",
    "What is not covered by home insurance?",
    "How much home insurance coverage do you need?"
  ],
  additionalInfo: {
    overview: "Home insurance is a crucial investment for protecting your home and your belongings. It can provide financial support if your home is damaged or destroyed, if your possessions are stolen, or if someone is injured on your property. But what exactly is home insurance and how does it work?",
    sections: [
      {
        title: "Types of home insurance policies:",
        paragraphs: [
          "HO-1: Provides basic coverage for a limited number of perils.",
          "HO-2: Provides broader coverage for more types of perils than HO-1.",
          "HO-3: Provides all risk coverage for your home and named perils coverage for your personal property."
        ]
      }
    ]
  },
  pricingFactors: {
    title: "Main Price Impacting Factors for Home Insurance",
    description: "When comparing rates and coverages for home insurance, it is important to keep in mind data points that Insurance Companies find most important when evaluating your rate.",
    factors: [
      {
        title: "Multi-Policy Discount",
        description: "It goes without saying, Insurance Companies like when you purchase more than one policy with them. Consider this when you are getting one policy, they may give a deeper discount by adding another.",
        imageUrl: "@/assets/images/productPageImages/multi.png"
      },
      {
        title: "Claims History",
        description: "Insurance companies heavily factor in how many claims you've had in the past. If you've had multiple claims in a short period, you'll likely face higher premiums.",
        imageUrl: "@/assets/images/productPageImages/multi.png"
      },
      {
        title: "Credit Score",
        description: "Your credit score can significantly impact your home insurance rates. Most insurance companies view a higher credit score as an indicator of responsibility, which may lead to lower premiums.",
        imageUrl: "@/assets/images/productPageImages/credit.png"
      },
      {
        title: "Home Features and Location",
        description: "Your home's age, construction type, and location all play major roles in determining your premium. Older homes, those in high-risk weather areas, or homes with outdated systems may cost more to insure.",
        imageUrl: "@/assets/images/productPageImages/marital.png"
      }
    ]
  },
  relatedProducts: [
    {
      title: "Auto Insurance",
      imageUrl: "@/assets/images/product-type-icons/autoInsurance.svg",
      link: "/products/autoinsurance"
    },
    {
      title: "Flood Insurance",
      imageUrl: "@/assets/images/product-type-icons/floodInsurance.svg",
      link: "/products/floodinsurance"
    },
    {
      title: "Life Insurance",
      imageUrl: "@/assets/images/product-type-icons/lifeInsurance.svg",
      link: "/products/lifeinsurance"
    }
  ],
  ctaText: "(Auto, Life, Flood, etc.)"
}; 